export const PROFILE_DASHBOARD_ICONS = {
  orders: '/main/dashboardicons/orders.svg',
  offers: '/main/dashboardicons/offers.svg',
  seller: '/main/dashboardicons/seller.svg',
  boosting: '/main/dashboardicons/boosting.svg',
  wallet: '/main/dashboardicons/wallet.svg',
  message: '/main/dashboardicons/message.svg',
  bell: '/main/dashboardicons/bell.svg',
  feedback: '/main/dashboardicons/feedback.svg',
  profile: '/main/dashboardicons/profile.svg',
};

export function getProfileNavSections(user, t = (_key, fallback) => fallback) {
  return [
    {
      id: 'marketplace',
      label: t('profile.navMarketplace', 'Marketplace'),
      items: [
        {
          id: 'orders',
          label: 'Orders',
          iconPath: PROFILE_DASHBOARD_ICONS.orders,
          hasDropdown: true,
          path: '/profile/orders',
          subItems: [
            { id: 'purchased-orders', label: t('profile.purchasedOrders', 'Purchased orders'), path: '/profile/orders/purchased' },
            { id: 'sold-orders', label: t('profile.soldOrders', 'Sold orders'), path: '/profile/orders/sold' },
          ],
        },
        {
          id: 'offers',
          label: 'Offers',
          iconPath: PROFILE_DASHBOARD_ICONS.offers,
          hasDropdown: true,
          path: '/profile/offers',
          subItems: [
            { id: 'offers-currency', label: 'Currency', path: '/profile/offers/currency' },
            { id: 'offers-accounts', label: 'Accounts', path: '/profile/offers/accounts' },
            { id: 'offers-topups', label: 'Top Ups', path: '/profile/offers/top-ups' },
            { id: 'offers-items', label: 'Items', path: '/profile/offers/items' },
          ],
        },
        { id: 'wallet', label: 'Wallet', iconPath: PROFILE_DASHBOARD_ICONS.wallet, hasDropdown: false, path: '/profile/wallet' },
        { id: 'messages', label: 'Messages', iconPath: PROFILE_DASHBOARD_ICONS.message, hasDropdown: false, path: '/profile/messages' },
        { id: 'notifications', label: 'Notifications', iconPath: PROFILE_DASHBOARD_ICONS.bell, hasDropdown: false, path: '/profile/notifications' },
      ],
    },
    {
      id: 'selling',
      label: t('profile.navSelling', 'Selling'),
      items: [
        {
          id: 'seller',
          label: 'Seller',
          iconPath: PROFILE_DASHBOARD_ICONS.seller,
          hasDropdown: true,
          path: '/profile/seller',
          subItems: [
            { id: 'become-seller', label: 'Become a Seller', path: '/profile/become-seller' },
            { id: 'seller-purchased-orders', label: 'Purchased Orders', path: '/profile/seller/purchased-orders' },
            { id: 'seller-sold-orders', label: 'Sold Orders', path: '/profile/seller/sold-orders' },
            { id: 'seller-my-items', label: 'My Items', path: '/profile/seller/my-items' },
            { id: 'seller-requests', label: 'Requests', path: '/profile/seller/requests' },
          ],
        },
        {
          id: 'boosting',
          label: 'Boosting',
          iconPath: PROFILE_DASHBOARD_ICONS.boosting,
          hasDropdown: true,
          path: user?.is_seller ? '/profile/boosting/received' : '/profile/boosting/my-requests',
          subItems: [
            { id: 'my-boosting-requests', label: t('profile.myRequests', 'My requests'), path: '/profile/boosting/my-requests' },
            ...(user?.is_seller
              ? [{ id: 'received-boosting-requests', label: t('profile.receivedRequests', 'Received requests'), path: '/profile/boosting/received' }]
              : []),
          ],
        },
        { id: 'feedback', label: 'Feedback', iconPath: PROFILE_DASHBOARD_ICONS.feedback, hasDropdown: false, path: '/profile/feedback' },
      ],
    },
    {
      id: 'account',
      label: t('profile.navAccount', 'Account'),
      items: [
        { id: 'account', label: 'Account settings', iconPath: PROFILE_DASHBOARD_ICONS.profile, hasDropdown: false, path: '/profile/account' },
        { id: 'profile', label: 'View Profile', iconPath: PROFILE_DASHBOARD_ICONS.profile, hasDropdown: false, path: '/profile/view' },
      ],
    },
  ];
}

export function isProfileNavPathActive(item, pathname) {
  if (item.subItems?.length) {
    return item.subItems.some((sub) => isProfileNavPathActive(sub, pathname));
  }
  if (!item.path) return false;
  if (item.path === '/profile/account') {
    return pathname === '/profile/account' || pathname === '/profile';
  }
  return pathname === item.path;
}
